export { default } from './SendTrackViewPageEvent';
